import React, { useEffect, useState } from "react";
import Personal from "./Patient/Personal";
import ContactDetails from "./Patient/ContactDetails";
import EmergencyContact from "./Patient/EmergencyContact";
import { usePatient } from "../../contexts";
import { get, post, put } from "../../utility/fetch";
import ClientList from "../layouts/ClientList";
import { HiPlus } from "react-icons/hi";
import notification from "../../utility/notification";

function PatientDetails() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [admit, setAdmit] = useState('appointment');
  const [appointment, setAppointment] = useState(false);
  const { patientId, patientName, patientInfo, setPatientInfo, nurseRoles } = usePatient();
  const [selectedTab, setSelectedTab] = useState('personal');
  const [combinedData, setCombinedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [admittedPatient, setAdmittedPatients] = useState([]);
  const [lgas, setLgas] = useState([]);
  const [states, setStates] = useState([]);
  const [view, setView] = useState("notexisting");
  const [formLoading, setFormLoading] = useState(false);
  const [payload, setPayload] = useState({
    firstName: "",
    lastName: "",
    gender: "",
    dateOfBirth: "",
    pictureUrl: "",
    nin: "",
    stateOfOrigin: "",
    lga: "",
    placeOfBirth: "",
    maritalStatus: "",
    nationality: "",
    stateOfResidence: "",
    lgaResidence: "",
    city: "",
    homeAddress: "",
    phone: "",
    email: "",
    altPhone: "",
    emergencyRelationship: "",
    emergencyfirstName: "",
    emergencyLastName: "",
    emergencyPhone: "",
    emergencyEmail: "",
    emergencyContactAddress: "",
    emergencyStateOfResidence: "",
    emergencyLga: "",
    emergencyCity: "",
    emergencyAltPhone: ""
  });

  // Get 'emp' query parameter
  const queryParams = new URLSearchParams(window.location.search);
  const empParam = queryParams.get('emp');

  console.log(empParam)

  useEffect(() => {


    const fetchPatientData = async () => {
      setFormLoading(true)
      try {
      let statess = await fetchStates();

        if (empParam) {
          // Subtract 12345 from emp value
          const patientId = Number(empParam) - 12345;

          // Make API call with calculated ID
          const response = await get(`/patient/${patientId}`);
          console.log(response)
          if (response?.statusCode === 200) {
            // Set patient data to state
            console.log(statess)
            if (statess?.length > 0) {
              let state = statess.find(state => state.name === response?.data?.stateOfOrigin);
              console.log(state)
              if (state) {
                let lgass = await getLgas(state.value);

                let localLga = lgass.find(lga => lga.name === response?.data?.lga);
                console.log(localLga)
                if (localLga) {
                  setPatientInfo((prevPayload) => ({ ...response.data, lga: localLga.name, lgaId: localLga.value, stateOfOrigin: state.name, stateId: state.value }));
                  setPayload((prevPayload) => ({ ...response.data, lga: localLga.name, lgaId: localLga.value, stateOfOrigin: state.name, stateId: state.value }));
                  setFormLoading(false)
                }
              }
              else{
                setFormLoading(false)
                setPatientInfo((prevPayload) => ({ ...response.data }));
              }
            }
            // setPatientInfo(response.data);
          }
        }
      } catch (error) {
        console.error('Error fetching patient:', error);
        notification({
          message: 'Error fetching patient details',
          type: "error"
        });
      }
    };

    fetchPatientData();

  }, [window.location?.search]);


  useEffect(() => {

  }, [])

  const showAddPatientTabs = localStorage.getItem("showAddPatientTabs") === "true";

  const closeModal = () => {
    setIsModalOpen(false);
    setAppointment(false);
    sessionStorage.setItem("personalInfo", JSON.stringify({}));
    sessionStorage.setItem("patientId", '');
  };

  const selectRecord = () => () => {
    setIsModalOpen(true);
  };

  const submit = async () => {
    let updatedPayload = {
      firstName: payload.firstName,
      lastName: payload.lastName,
      gender: payload.gender,
      dateOfBirth: payload.dateOfBirth,
      pictureUrl: payload.pictureUrl,
      nin: payload.nin,
      stateOfOrigin: payload.stateOfOrigin,
      lga: payload.lga,
      weight: Number(payload.weight),
      placeOfBirth: payload.placeOfBirth,
      maritalStatus: payload.maritalStatus,
      nationality: payload.nationality,
      contact: {
        phone: payload.phone,
        email: payload.email,
        contactAddress: payload?.homeAddress,
        stateOfresidence: payload.stateOfResidence,
        homeAddress: payload?.homeAddress,
        lgaResidence: payload?.lgaResidence,
        city: payload?.city,
        altPhone: payload?.altPhone,
      },
      emergencyContact: {
        firstName: payload.emergencyfirstName,
        lastName: payload.emergencyLastName,
        phone: payload.emergencyPhone,
        email: payload.emergencyEmail,
        contactAddress: payload?.emergencyContactAddress,
        stateOfResidence: payload?.emergencyStateOfResidence,
        lga: payload?.emergencyLga,
        city: payload?.emergencyCity,
        altPhone: payload?.emergencyAltPhone,
        relationship: payload?.emergencyRelationship,
      }

    }
    const patientId = Number(empParam) - 12345;
    // let res = await post('/patient', updatedPayload)
    let res = await put(`/patient/${patientInfo?.id}`, updatedPayload)

    if (res.statusCode = 200) {
      notification({ message: res?.data?.message, type: "success" });
      setSelectedTab('client');
      console.log(res)
    }
  }




  const getAllAdmittedPatients = async () => {
    try {
      let res = await get(`/patients/${patientId}/admited-patients?pageNumber=${currentPage}&pageSize=${10}`);
      setAdmittedPatients(res.data);
      setTotalPages(res.pageCount);
    } catch (error) {
      console.error('Error fetching all patients:', error);
    }
  };


  const fetchStates = async () => {
    let res;
    try {
       res = await get(`/healthcareprovider/getstates`);
      setStates([{ name: "Select State", value: "" },
      ...res?.map((state) => ({
        name: state?.state,
        value: state?.id,
      }))])
    } catch (error) {
    }

    return [{ name: "Select State", value: "" },
      ...res?.map((state) => ({
        name: state?.state,
        value: state?.id,
      }))]
  };


  const handleChange = (event) => {
    const { name, value } = event.target;

    if ((name === 'phone' || name === 'altPhone') && (isNaN(value) || value.length > 11)) {
      notification({ message: 'Please enter a valid phone number', type: "error" });
      return;
    }
    else if (name === "dateOfBirth") {
      const selectedDate = new Date(value);
      const currentDate = new Date();

      if (selectedDate >= currentDate) {
        notification({ message: 'Date selected cannot be a future date', type: "error" });
        return;
      }
    }

    //  else if (name === 'phoneNumber') {
    //   if ((value.length <= 11 && isNaN(value)) || value.length > 11) {
    //     notification({ message: 'Please enter a valid phone number', type: "error" });
    //     return;
    //   }
    // }

    else if (name === 'weight') {
      if ((isNaN(value))) {

        notification({ message: 'Please enter a valid number', type: "error" });
        return;
      }
      setPayload(prevPayload => ({ ...prevPayload, [name]: Number(value) }));
    }

    else if (name === 'stateOfOrigin') {
      let state = states.find(state => state.value === value);
      console.log(state)
      console.log(states)
      if (state) {
        setPayload(prevPayload => ({ ...prevPayload, stateOfOrigin: state.name, stateId: Number(state.value) }));
        getLgas(value);
      }
      return;
    }
    else if (name === 'lga') {
      let localLga = lgas.find(lga => lga.value === value);
      if (localLga) {
        setPayload(prevPayload => ({...prevPayload, lga: localLga.name, lgaId: Number(localLga.value) }));
      }
      return;

    }

    setPayload(prevPayload => ({ ...prevPayload, [name]: value }));
  };





  const getLgas = async (id) => {
    let response = await get(`/healthcareprovider/getlgasbystateid/id/${id}`);

    setLgas([{ name: "Select Lga", value: 0 },
    ...response.map((lga) => ({
      name: lga?.lga,
      value: lga?.id,
    }))])

    return [{ name: "Select Lga", value: 0 },
    ...response.map((lga) => ({
      name: lga?.lga,
      value: lga?.id,
    }))]
  }


  const fetchData = async (currentPage) => {
    try {
      const response = await get(`/appointment/get-appointment-bypatientId/${patientId}?pageIndex=${currentPage}&pageSize=10`);
      setCombinedData(response?.data);
    } catch (e) {
      console.error('Error fetching appointments:', e);
    }
  };

  useEffect(() => {
    getAllAdmittedPatients(currentPage);
  }, [currentPage]);

  const renderTabContent = (selectedTab) => {
    switch (selectedTab) {
      case "client":
        return <ClientList hide={true} setSelectedTab={setSelectedTab} renderTabContent={renderTabContent} />;
      case "personal":
        return <Personal empParam={empParam} states={states} formLoading={formLoading} setStates={setStates} payload={payload} lgas={lgas} getLgas={getLgas} setPayload={setPayload} handleChange={handleChange} hide={true} setSelectedTab={setSelectedTab} renderTabContent={renderTabContent} />;
      case "contact":
        return <ContactDetails empParam={empParam} formLoading={formLoading}  payload={payload} setPayload={setPayload} handleChange={handleChange} setSelectedTab={setSelectedTab} hide={true} renderTabContent={renderTabContent} />;
      case "emergency":
        return <EmergencyContact empParam={empParam} formLoading={formLoading}  submit={submit} payload={payload} setPayload={setPayload} handleChange={handleChange} renderTabContent={renderTabContent} />;
      case "medicalRecord":
      //   return <MedicalRecord renderTabContent={renderTabContent} />;
      // case "immunization":
      //   return <Immunization renderTabContent={renderTabContent} />;
      // case "vitals":
      //   return <Vitals renderTabContent={renderTabContent} />;
      // case "treatment":
      //   return <Treatments renderTabContent={renderTabContent} />;
      // case "order":
      //   return <OrderTable renderTabContent={renderTabContent} />;
      // case "financeHmo":
      //   return <Finance_HMO />;
      // case "diagnosis":
      //   return <DiagnosisTable />;
      // case "appointment":
      //   return <Appointment data={combinedData} setCurrent={setCurrentPage} />;
      default:
        return <Personal setSelectedTab={setSelectedTab} renderTabContent={renderTabContent} />;
    }
  };


  return (
    <div className="w-100">
      <div className="m-t-80 flex flex-h-center flex-v-center space-between">
        <h3>{patientName}</h3>
        <div className="m-b-10 flex flex-h-end col-5">

          {/* <button onClick={() => { setView('notExisting'); setSelectedTab('personal') }} className="flex rounded-5 p-20 flex-h-center flex-v-center btn m-l-10">
            <HiPlus className="m-r-10" color="white" /> <span>Add New Patient</span>
          </button> */}

          {/* {nurseRoles.includes('checkin') && patientInfo && (
            <button onClick={() => { setAppointment(true); setAdmit('appointment'); }} className="save-drafts m-l-10">
              Book an Appointment
            </button>
          )} */}
        </div>
      </div>

      <div className="tabs m-t-20 bold-text">
        <>
          {
            view === "existing" ? <>
              <div
                className={`tab-item ${selectedTab === "client" ? "active" : ""}`}
                onClick={() => setSelectedTab("client")}
              >
                Client List
              </div>
              {/* <div
                className={`tab-item ${selectedTab === "online" ? "active" : ""}`}
                onClick={() => setSelectedTab("online")}
              >
                Online Orders
              </div> */}
              {/* <div
                className={`tab-item ${selectedTab === "referred" ? "active" : ""}`}
                onClick={() => setSelectedTab("referred")}
              >
                Referred Patients
              </div>
              <div
                className={`tab-item ${selectedTab === "appointments" ? "active" : ""}`}
                onClick={() => setSelectedTab("appointments")}
              >
                Referred Patients
              </div> */}
              {/* <div
                className={`tab-item ${selectedTab === "diagnosis" ? "active" : ""}`}
                onClick={() => setSelectedTab("diagnosis")}
              >
                Diagnosis
              </div>
              <div
                className={`tab-item ${selectedTab === "order" ? "active" : ""}`}
                onClick={() => setSelectedTab("order")}
              >
                Place Order
              </div>
              <div
                className={`tab-item ${selectedTab === "labs" ? "active" : ""}`}
                onClick={() => setSelectedTab("labs")}
              >
                Labs
              </div>
              <div
                className={`tab-item ${selectedTab === "financeHmo" ? "active" : ""}`}
                onClick={() => setSelectedTab("financeHmo")}
              >
                Finance/HMO
              </div> */}
            </>
              :
              <>
                <div
                  className={`tab-item ${selectedTab === "personal" ? "active" : ""}`}
                  onClick={() => setSelectedTab("personal")}
                >
                  Personal
                </div>
                <div
                  className={`tab-item ${selectedTab === "contact" ? "active" : ""}`}
                  onClick={() => setSelectedTab("contact")}
                >
                  Contact Details
                </div>
                <div
                  className={`tab-item ${selectedTab === "emergency" ? "active" : ""}`}
                  onClick={() => setSelectedTab("emergency")}
                >
                  Emergency Contact
                </div>

              </>
          }
        </>
      </div>

      <div>
        {renderTabContent(selectedTab)}
      </div>

      {
        appointment && (
          <div></div>
          // <AppointmentModal
          //   closeModal={closeModal}
          //   type={admit}
          //   fetchData={fetchData}
          //   currentPage={currentPage}
          // />
        )
      }
    </div>
  );
}

export default PatientDetails;
